import { numberInputClasses as baseNumberInputClasses } from '@mui/base/Unstable_NumberInput/index.js';
import styled, { css } from 'styled-components';
import { HTMLInput, inputClasses, Root } from './shared/Input.styled.js';
export const numberInputClasses = {
    ...inputClasses,
    ...baseNumberInputClasses,
};
export const NumberRoot = styled(Root)(({ theme }) => css `
    display: inline-grid;
    grid-template-columns: auto 1fr auto ${theme.spacing.md};
    grid-template-rows: 1fr 1fr;
    overflow: hidden;

    &.${inputClasses.sizeMd} {
      grid-template-columns: auto 1fr auto ${theme.spacing.lg};
    }
  `);
export const HTMLNumberInput = styled(HTMLInput)(({ theme }) => css `
    &.${numberInputClasses.input} {
      grid-row: 1/3;

      margin-left: ${theme.spacing.sm};

      .input-md & {
        margin-left: ${theme.spacing.xs};
      }

      .input-adornment-start + & {
        margin-left: 0;
      }
    }
  `);
export const StepperButton = styled('button')(({ theme }) => css `
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    appearance: none;
    box-sizing: border-box;
    padding: 0;
    width: ${theme.spacing.sm};
    height: ${theme.spacing.sm};
    font-family: system-ui, sans-serif;
    font-size: 0.875rem;
    line-height: 1;
    background: none;
    border: none;
    color: ${theme.palette.contrastHigh};
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 120ms;

    .input-md & {
      width: ${theme.spacing.md};
      height: ${theme.spacing.md};
    }

    &:hover {
      cursor: pointer;
      background: ${theme.palette.primary};
      border-color: ${theme.palette.primary};
      color: ${theme.palette.surface};
    }

    &.${numberInputClasses.incrementButton} {
      grid-column: 4/5;
      grid-row: 1/2;
      border-top-left-radius: 2px;
      border-top-right-radius: 2px;
      border-bottom-width: 0;
      margin-bottom: -3px;

      .input-md & {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
    }

    &.${numberInputClasses.decrementButton} {
      grid-column: 4/5;
      grid-row: 2/3;
      border-bottom-left-radius: 2px;
      border-bottom-right-radius: 2px;
      margin-top: -3px;

      .input-md & {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }

    & .arrow {
      transform: translateY(-1px);
    }
  `);
